// removed by extract-text-webpack-plugin
module.exports = {"container":"container-2stzQ container-2zf3r container-3-GEX input-2t6DG label-Y5lvX","input":"input-3EQo7","selected":"selected-1oMWA selected-3AQ2E","icon":"icon-3E5tr icon-3R4VN","iconContainer":"iconContainer-2By_s iconContainer-2tBn1","iconDot":"iconDot-3SDO9 iconDot-zoqvD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/CheckboxField/_checkboxButton.css
// module id = 1187
// module chunks = 1